<script>
import { hmdaGetters, broadcastGetters, hmdaMethods } from '@/src/state/helpers'
import constant from '@constants/constant'
import FilterDate from '@/src/components/HMDA/FilterDate.vue'

const EventCodes = {
  run_rules: 1,
  delete_item: 2,
  download_report:3
}

export default {
  components: { FilterDate },

  props: {
    projectId: { type: [String, Number], default: '' }

  },

  data() {
    return {
      modalDelete: null,
      showSpinner: false,
      projectStatus: null,
      projectStatuses: [
        constant.hmdaProjectStatus.new,
        constant.hmdaProjectStatus.inProgress,
        constant.hmdaProjectStatus.completed,
      ],
      options: [25, 50, 75, 100],
      newLoansList: [],
      newLoansRows: 0,
      newLoansPerPage: 25,
      newLoansCurrentPage: 1,
      passedLoansList: [],
      passedLoansRows: 0,
      passedLoansPerPage: 25,
      passedLoansCurrentPage: 1,
      failedLoansList: [],
      failedLoansRows: 0,
      failedLoansPerPage: 25,
      failedLoansCurrentPage: 1,
      datatypeLoansList: [],
      datatypeLoansRows: 0,
      datatypeLoansPerPage: 25,
      datatypeLoansCurrentPage: 1,
      deletedLoansList: [],
      deletedLoansRows: 0,
      deletedLoansPerPage: 25,
      deletedLoansCurrentPage: 1,
      newLoanfields: [
        {
          key: 'customselect',
          label: 'Select',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'refItem',
          label: 'Loan Number',
          refValField: 'loanNumber',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'applicationDate',
          label: 'Application Date',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'actionTaken',
          label: 'Action Taken',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'actionTakenDate',
          label: 'Action Date',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'loanPurpose',
          label: 'Loan Purpose',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'ruleStatus',
          label: 'Rule Status',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'lastRunTime',
          label: 'Last run time',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'errorCount',
          label: 'Error count',
          sortable: false,
          class: 'text-left',
        },
      ],
      deletedLoanTable:
      [
        {
          key: 'customselect',
          label: 'Select',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'loanNumber',
          label: 'Loan Number',
          refValField: 'loanNumber',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'deletedDate',
          label: 'Deleted Date',
          sortable: true,
          class: 'text-left',
        }
      ],
      fields: [
        {
          key: 'customselect',
          label: 'Select',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'refItem',
          label: 'Loan Number',
          refValField: 'loanNumber',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'applicationDate',
          label: 'Application Date',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'actionTaken',
          label: 'Action Taken',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'actionTakenDate',
          label: 'Action Date',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'loanPurpose',
          label: 'Loan Purpose',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'ruleStatus',
          label: 'Rule Status',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'lastRunTime',
          label: 'Last run time',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'errorCount',
          label: 'Error count',
          sortable: true,
          class: 'text-left',
        },
      ],
      deletionOptions: [
        {text: 'Client request', value: 'Client request'},
        {text: 'Upload failure', value: 'Upload failure'},
        {text: 'Invalid loan', value: 'Invalid loan'},
        {text: 'Other (add reason) ', value: 'other'}
      ],
      deletedOption: '',
      isDeleteWindow: false,
      otherInput:'',
      showCustomReportIssue: false,
      newLoanSortByColoumn: '',
      newLoanSortByDirection: 0,
      passedLoanSortByColoumn: '',
      passedLoanSortByDirection: 0,
      failedLoanSortByColoumn: '',
      failedLoanSortByDirection: 0,
      deletedLoanSortByColoumn: '',
      deletedLoanSortByDirection: 0,
      datatypeLoanSortByColoumn: '',
      datatypeLoanSortByDirection: 0,
      newLoanFromDate: '',
      newLoanToDate: '',
      passedLoanFromDate: '',
      passedLoanToDate: '',
      failedLoanFromDate: '',
      failedLoanToDate: '',
      deletedLoanFromDate: '',
      deletedLoanFromDateLoanToDate: '',
      datatypeLoanFromDate: '',
      datatypeLoanToDate: '',
      commands: [
        {
          text: 'Run rules',
          event: EventCodes.run_rules,
          icon: 'sync',
          requiresSelect: true,
          tooltip: 'Run Rules on Selected Loans',
        },
      ],
      failedLoanCommands: [
        {
          text: 'Run rules',
          event: EventCodes.run_rules,
          icon: 'sync',
          requiresSelect: true,
          tooltip: 'Run Rules on Selected Loans',
        },
        {
           text: 'Delete Item',
           requiresSelect: true,
           event: EventCodes.delete_item
        }
      ],
      deletedLoanCommands: [
        {
           text: 'Download Report',
           requiresSelect: true,
           event: EventCodes.download_report
        }
      ],
      totalNewLoans: 0,
      totalPassedLoans: 0,
      totalFailedLoans: 0,
      totalDeletedLoans: 0,
      totalDatatypeLoans: 0,
      selectedLoans: [],
      templateId: 1,
      projectDashboard: {},
      errSumArr1: [],
      errSumArr2: [],
      asynRequests: [],
      isProjectLevelRuleExecution: false,
      isIncludePassedLoans: false,
      isShowErrorSummary: false,
      counter: 0,
      loanQuery: {},
      tabId: 2,
      newLoanId: constant.hmdaLoanType.New,
      passedLoanId: constant.hmdaLoanType.Passed,
      failedLoanId: constant.hmdaLoanType.Failed,
    //  deletedLoanId: constant.hmdaLoanType.Deleted,
      dataTypeLoanId: constant.hmdaLoanType.DataTypeMisMatch,
      recentProjectStatus: null,
      showRuleExecCheckbox: true,
    }
  },

  computed: {
    ...hmdaGetters,
    ...broadcastGetters,
    USER_ID() {
      return this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.userInfo.userId || null
        : null
    },
  },

  watch: {
    messageTypeRuleEngine(m) {
      if (Number(m.RuleEngineStatus.ProjectId) === Number(this.projectId)) {
        this.reloadAllData()
      }
    },

    messageTypeFileUpload(n) {
      if (Number(n.ProjectId) === Number(this.projectId)) {
        this.reloadAfterFilesProcessed()
      }
    },
  },

  mounted() {
    this.reloadAllData()
  },
  methods: {
    ...hmdaMethods,

    reloadAfterFilesProcessed() {
      this.getProjectSummary()
      this.getProjectDashboard()
      this.getNewLoans()
      this.getDeletedLoans()
      // this.getDatatypeLoans()
    },

    reloadAllData() {
      this.getProjectSummary()
      this.getProjectDashboard()
      this.getNewLoans()
      this.getPassedLoans()
      this.getFailedLoans()
      this.getDeletedLoans()
      // this.getDatatypeLoans()
    },

    setSpinnerBusy() {
      this.asynRequests.push(1)
      if (!this.showSpinner) {
        this.showSpinner = true
      }
    },

    unsetSpinnerBusy() {
      this.asynRequests.pop()
      if (this.asynRequests.length === 0) {
        this.showSpinner = false
      }
    },

    getProjectSummary() {
      this.setSpinnerBusy()
      this.fetchProjectSummary({
        projectId: this.projectId,
      })
        .then((r) => {
          if (r) {
            this.projectStatus = r.data ? r.data.status : null
            this.recentProjectStatus = this.projectStatus
          }
        })
        .finally(() => {
          this.unsetSpinnerBusy()
        })
    },

    onClickErrorSummary() {
      if (this.counter % 2 === 0) {
        this.getProjectErrorSummary()
      } else {
        this.isShowErrorSummary = !this.isShowErrorSummary
      }
      this.counter++
    },

    getProjectErrorSummary() {
      this.setSpinnerBusy()
      this.fetchProjectErrorSummary({
        projectId: this.projectId,
      })
        .then((response) => {
          const length = response.data ? response.data.length || 0 : 0
          const half = Math.ceil(length / 2)
          this.errSumArr1 = response.data
            ? response.data.slice(0, half) || []
            : []
          this.errSumArr2 = response.data ? response.data.slice(half) || [] : []
          this.isShowErrorSummary = true
        })
        .finally(() => {
          this.unsetSpinnerBusy()
        })
    },

    getProjectDashboard() {
      this.setSpinnerBusy()
      this.fetchProjectDashboard({
        ProjectId: this.projectId,
      })
        .then((response) => {
          this.projectDashboard = response.data
        })
        .finally(() => {
          this.unsetSpinnerBusy()
        })
    },

    getNewLoans() {
      this.setSpinnerBusy()
      this.fetchProjectNewLoans({
        ProjectId: this.projectId,
        PageSize: this.newLoansPerPage,
        PageNumber: this.newLoansCurrentPage,
        SortBy: this.newLoanSortByColoumn,
        SortDirection: this.newLoanSortByDirection,
        FromDate: this.newLoanFromDate,
        ToDate: this.newLoanToDate,
      })
        .then((response) => {
          const newLoansList = response ? response.data.loans || [] : []
          newLoansList.forEach((l) => {
            if (l.loanNumber === null || l.loanNumber === '') {
              l.loanNumber = 'Invalid LEI or ULI'
            }
          })
          this.newLoansList = newLoansList
          this.newLoansRows = response.data.totalLoansCount
          this.totalNewLoans = response.data.projectLoansCount
          this.newLoansCurrentPage = this.newLoansCurrentPage
          this.unsetSpinnerBusy()
        })
        .catch(() => {
          this.unsetSpinnerBusy()
        })
    },

    getPassedLoans() {
      this.setSpinnerBusy()
      this.fetchProjectPassedLoans({
        ProjectId: this.projectId,
        PageSize: this.passedLoansPerPage,
        PageNumber: this.passedLoansCurrentPage,
        SortBy: this.passedLoanSortByColoumn,
        SortDirection: this.passedLoanSortByDirection,
        FromDate: this.passedLoanFromDate,
        ToDate: this.passedLoanToDate,
      })
        .then((response) => {
          const passedLoansList = response ? response.data.loans || [] : []
          passedLoansList.forEach((l) => {
            if (l.loanNumber === null || l.loanNumber === '') {
              l.loanNumber = 'Invalid LEI or ULI'
            }
          })
          this.passedLoansList = passedLoansList
          this.passedLoansRows = response.data.totalLoansCount
          this.totalPassedLoans = response.data.projectLoansCount
          this.passedLoansCurrentPage = this.passedLoansCurrentPage
          this.unsetSpinnerBusy()
        })
        .catch(() => {
          this.unsetSpinnerBusy()
        })
    },

    getFailedLoans() {
      this.setSpinnerBusy()
      this.fetchProjectFailedLoans({
        ProjectId: this.projectId,
        PageSize: this.failedLoansPerPage,
        PageNumber: this.failedLoansCurrentPage,
        SortBy: this.failedLoanSortByColoumn,
        SortDirection: this.failedLoanSortByDirection,
        FromDate: this.failedLoanFromDate,
        ToDate: this.failedLoanToDate,
      })
        .then((response) => {
          const failedLoansList = response ? response.data.loans || [] : []
          failedLoansList.forEach((l) => {
            if (l.loanNumber === null || l.loanNumber === '') {
              l.loanNumber = 'Invalid LEI or ULI'
            }
          })
          this.failedLoansList = failedLoansList
          this.failedLoansRows = response.data.totalLoansCount
          this.totalFailedLoans = response.data.projectLoansCount
          this.failedLoansCurrentPage = this.failedLoansCurrentPage
          this.unsetSpinnerBusy()
        })
        .catch(() => {
          this.unsetSpinnerBusy()
        })
    },

    getDeletedLoans() {
      this.setSpinnerBusy()
      this.fetchProjectDeletedLoans({
        ProjectId: this.projectId,
        PageSize: this.deletedLoansPerPage,
        PageNumber: this.deletedLoansCurrentPage,
        SortBy: this.deletedLoanSortByColoumn,
        SortDirection: this.deletedLoanSortByDirection
      })
        .then((response) => {
          const deletedLoansList = response ? response.data.item1 || [] : []
          deletedLoansList.forEach((l) => {
            if (l.loanNumber === null || l.loanNumber === '') {
              l.loanNumber = 'Invalid LEI or ULI'
            }
            l.deletedDate = new Date(l.deletedDate).toLocaleString('en-Us', {
                 year: 'numeric',
                 month: '2-digit',
                 day: '2-digit',
            });
          })
          this.deletedLoansList = deletedLoansList
          this.deletedLoansRows = response.data.item2
          this.totalDeletedLoans = response.data.item3
          this.deletedLoansCurrentPage = this.deletedLoansCurrentPage
          this.unsetSpinnerBusy()
        })
        .catch(() => {
          this.unsetSpinnerBusy()
        })
    },

    // getDatatypeLoans() {
    //   this.setSpinnerBusy()
    //   this.fetchProjectDatatypeLoans({
    //     ProjectId: this.projectId,
    //     PageSize: this.datatypeLoansPerPage,
    //     PageNumber: this.datatypeLoansCurrentPage,
    //     SortBy: this.datatypeLoanSortByColoumn,
    //     SortDirection: this.datatypeLoanSortByDirection,
    //     FromDate: this.datatypeLoanFromDate,
    //     ToDate: this.datatypeLoanToDate,
    //   })
    //     .then((response) => {
    //       const datatypeLoansList = response ? response.data.loans || [] : []
    //       datatypeLoansList.forEach((l) => {
    //         if (l.loanNumber === null || l.loanNumber === '') {
    //           l.loanNumber = 'Invalid LEI or ULI'
    //         }
    //       })
    //       this.datatypeLoansList = datatypeLoansList
    //       this.datatypeLoansRows = response.data.totalLoansCount
    //       this.totalDatatypeLoans = response.data.projectLoansCount
    //       this.datatypeLoansCurrentPage = this.datatypeLoansCurrentPage
    //       this.unsetSpinnerBusy()
    //     })
    //     .catch(() => {
    //       this.unsetSpinnerBusy()
    //     })
    // },

    getTabId(id) {
      this.tabId = id
    },

    goToLoanDetails(loan) {
      if (this.tabId === 0) {
        this.loanQuery = {
          LoanId: loan.larDetailId,
          PageSize: this.newLoansPerPage,
          PageNumber: this.newLoansCurrentPage,
          ProjectId: this.projectId,
          SortBy: this.newLoanSortByColoumn,
          SortDirection: this.newLoanSortByDirection,
          FromDate: this.newLoanFromDate,
          ToDate: this.newLoanToDate,
          LoanType: this.tabId,
          nextLoanNumber: 0,
          previousLoanNumber: 0,
        }
      } else if (this.tabId === 1) {
        this.loanQuery = {
          LoanId: loan.larDetailId,
          PageSize: this.passedLoansPerPage,
          PageNumber: this.passedLoansCurrentPage,
          ProjectId: this.projectId,
          SortBy: this.passedLoanSortByColoumn,
          SortDirection: this.passedLoanSortByDirection,
          FromDate: this.passedLoanFromDate,
          ToDate: this.passedLoanToDate,
          LoanType: this.tabId,
          nextLoanNumber: 0,
          previousLoanNumber: 0,
        }
      } else if (this.tabId === 2) {
        this.loanQuery = {
          LoanId: loan.larDetailId,
          PageSize: this.failedLoansPerPage,
          PageNumber: this.failedLoansCurrentPage,
          ProjectId: this.projectId,
          SortBy: this.failedLoanSortByColoumn,
          SortDirection: this.failedLoanSortByDirection,
          FromDate: this.failedLoanFromDate,
          ToDate: this.failedLoanToDate,
          LoanType: this.tabId,
          nextLoanNumber: 0,
          previousLoanNumber: 0,
        }
      } else if (this.tabId === 3) {
        this.loanQuery = {
          LoanId: loan.larDetailId,
          PageSize: this.datatypeLoansPerPage,
          PageNumber: this.datatypeLoansCurrentPage,
          ProjectId: this.projectId,
          SortBy: this.datatypeLoanSortByColoumn,
          SortDirection: this.datatypeLoanSortByDirection,
          FromDate: this.datatypeLoanFromDate,
          ToDate: this.datatypeLoanToDate,
          LoanType: this.tabId,
          nextLoanNumber: 0,
          previousLoanNumber: 0,
        }
      }
      localStorage.setItem('loanQuery', JSON.stringify(this.loanQuery))
      this.$router.push({
        name: 'hmda-project-loan-details',
        params: {
          projectId: this.projectId,
          loanId: loan.larDetailId,
        },
      })
    },

    paginationEventNewLoans(newLoansCurrentPage) {
      if (this.newLoansCurrentPage !== newLoansCurrentPage) {
        this.newLoansCurrentPage = newLoansCurrentPage
        this.getNewLoans()
      }
    },

    paginationEventPassedLoans(passedLoansCurrentPage) {
      if (this.passedLoansCurrentPage !== passedLoansCurrentPage) {
        this.passedLoansCurrentPage = passedLoansCurrentPage
        this.getPassedLoans()
      }
    },

    paginationEventFailedLoans(failedLoansCurrentPage) {
      if (this.failedLoansCurrentPage !== failedLoansCurrentPage) {
        this.failedLoansCurrentPage = failedLoansCurrentPage
        this.getFailedLoans()
      }
    },

      paginationEventDeletedLoans(deletedLoansCurrentPage) {
      if (this.deletedLoansCurrentPage !== deletedLoansCurrentPage) {
        this.deletedLoansCurrentPage = deletedLoansCurrentPage
        this.getDeletedLoans()
      }
    },

    // paginationEventDatatypeLoans(datatypeLoansCurrentPage) {
    //   if (this.datatypeLoansCurrentPage !== datatypeLoansCurrentPage) {
    //     this.datatypeLoansCurrentPage = datatypeLoansCurrentPage
    //     this.getDatatypeLoans()
    //   }
    // },

    rowPerPageCountNewLoans(pageValue) {
      this.newLoansPerPage = parseInt(pageValue)
      this.newLoansCurrentPage = 1
      if (this.newLoansRows !== 0) {
        this.getNewLoans()
      }
    },

    rowPerPageCountPassedLoans(pageValue) {
      this.passedLoansPerPage = parseInt(pageValue)
      this.passedLoansCurrentPage = 1
      if (this.passedLoansRows !== 0) {
        this.getPassedLoans()
      }
    },

    rowPerPageCountFailedLoans(pageValue) {
      this.failedLoansPerPage = parseInt(pageValue)
      this.failedLoansCurrentPage = 1
      if (this.failedLoansRows !== 0) {
        this.getFailedLoans()
      }
    },

      rowPerPageCountDeletedLoans(pageValue) {
      this.deletedLoansPerPage = parseInt(pageValue)
      this.deletedLoansCurrentPage = 1
      if (this.deletedLoansRows !== 0) {
        this.getDeletedLoans()
      }
    },

    // rowPerPageCountDatatypeLoans(pageValue) {
    //   this.datatypeLoansPerPage = parseInt(pageValue)
    //   this.datatypeLoansCurrentPage = 1
    //   if (this.datatypeLoansRows !== 0) {
    //     this.getDatatypeLoans()
    //   }
    // },

    sortingChanged(ctx) {
      let sortBy = ''
      if (ctx.sortBy === 'applicationDate') sortBy = 'applicationdate'
      else if (ctx.sortBy === 'actionTaken') sortBy = 'actiontaken'
      else if (ctx.sortBy === 'actionTakenDate') sortBy = 'actiontakendate'
      else if (ctx.sortBy === 'lastRunTime') sortBy = 'lastruntime'
      else if (ctx.sortBy === 'errorCount') sortBy = 'errorcount'
      return {
        sortByColoumn: sortBy,
        sortByDirection: ctx.sortDesc ? 1 : 0,
      }
    },

    sortingChangedNewLoans(ctx) {
      if (ctx.sortBy !== null && ctx.sortBy !== '') {
        const sortObj = this.sortingChanged(ctx)
        this.newLoanSortByColoumn = sortObj.sortByColoumn
        this.newLoanSortByDirection = sortObj.sortByDirection
        this.getNewLoans()
      }
    },

    sortingChangedPassedLoans(ctx) {
      if (ctx.sortBy !== null && ctx.sortBy !== '') {
        const sortObj = this.sortingChanged(ctx)
        this.passedLoanSortByColoumn = sortObj.sortByColoumn
        this.passedLoanSortByDirection = sortObj.sortByDirection
        this.getPassedLoans()
      }
    },

    sortingChangedFailedLoans(ctx) {
      if (ctx.sortBy !== null && ctx.sortBy !== '') {
        const sortObj = this.sortingChanged(ctx)
        this.failedLoanSortByColoumn = sortObj.sortByColoumn
        this.failedLoanSortByDirection = sortObj.sortByDirection
        this.getFailedLoans()
      }
    },

    // sortingChangedDatatypeLoans(ctx) {
    //   if (ctx.sortBy !== null && ctx.sortBy !== '') {
    //     const sortObj = this.sortingChanged(ctx)
    //     this.datatypeLoanSortByColoumn = sortObj.sortByColoumn
    //     this.datatypeLoanSortByDirection = sortObj.sortByDirection
    //     this.getDatatypeLoans()
    //   }
    // },

    getFilteredNewLoans(range) {
      const isRange = range.includes('to')
      this.newLoanFromDate = isRange ? range.split(' to ')[0] : range
      this.newLoanToDate = isRange ? range.split(' to ')[1] : range
      this.getNewLoans()
    },

    getFilteredPassedLoans(range) {
      const isRange = range.includes('to')
      this.passedLoanFromDate = isRange ? range.split(' to ')[0] : range
      this.passedLoanToDate = isRange ? range.split(' to ')[1] : range
      this.getPassedLoans()
    },

    getFilteredFailedLoans(range) {
      const isRange = range.includes('to')
      this.failedLoanFromDate = isRange ? range.split(' to ')[0] : range
      this.failedLoanToDate = isRange ? range.split(' to ')[1] : range
      this.getFailedLoans()
    },

    getFilteredDeletedLoans(range) {
      const isRange = range.includes('to')
      this.deletedLoanFromDate = isRange ? range.split(' to ')[0] : range
      this.deletedLoanToDate = isRange ? range.split(' to ')[1] : range
      this.getDeletedLoans();
    },

    // getFilteredDatatypeLoans(range) {
    //   const isRange = range.includes('to')
    //   this.datatypeLoanFromDate = isRange ? range.split(' to ')[0] : range
    //   this.datatypeLoanToDate = isRange ? range.split(' to ')[1] : range
    //   this.getDatatypeLoans()
    // },

    onClickRunRules(isProjLevel) {
      this.isProjectLevelRuleExecution = isProjLevel
      this.$refs.msg
        .showAsync(
          isProjLevel
            ? constant.hmdaMessages.cfmRuleExecOnProject
            : constant.hmdaMessages.cfmRuleExecOnOneLoan,
          'Confirm',
          constant.hmdaMessages.btnTextRunRules
        )
        .then(() => {
          this.setSpinnerBusy()
          let user = this.$store.state.auth.currentUser.userInfo
          let hmdacustomerid=window.localStorage.getItem('hmdacustomerid');
          let payload = {
            projectId: parseInt(this.projectId),
            customerId: hmdacustomerid,
            TemplateId: this.templateId,
            LarDetailIds: isProjLevel ? null : this.selectedLoans,
            IncludePassedLoans: this.isIncludePassedLoans,
          }
          this.postRunRules(payload).finally(() => {
            this.getProjectSummary()
            this.$emit('updateActivityLogs')
            this.unsetSpinnerBusy()
            this.isIncludePassedLoans = false
          })
        })
    },

    onCommandEvent(command) {
      switch (command) {
        case EventCodes.run_rules:
          this.onClickRunRules()
          break
        case EventCodes.delete_item:
          this.onDeleteLoanClick(true)
          break;
        case EventCodes.download_report:
          this.onDownloadCsv()
          break;
      }
    },

    onDownloadCsv() {
      let selectedIds = this.selectedLoans;
      this.setSpinnerBusy();
      this.downloadFailedLoansCsv({larIds: selectedIds}).then((response) => {
          let csvName = `report.csv`
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            var CSV = response.data
            var fullTemplate = [CSV]
            var blob1 = new Blob(fullTemplate, { type: 'text/html' })
            window.navigator.msSaveOrOpenBlob(blob1, csvName)
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', csvName)
            document.body.appendChild(link)
            link.click()
          }
          this.unsetSpinnerBusy();
        })
    },

    onRowSelected(val) {
      let selectedLoans = []
      val.forEach((row) => {
        selectedLoans.push(parseInt(row.larDetailId))
      })
      this.selectedLoans = selectedLoans
    },

    onDeletedRowSelected(val) {
      let selectedLoans = []
      val.forEach((row) => {
        selectedLoans.push(parseInt(row.larDetailsId))
      })
      this.selectedLoans = selectedLoans
    },

    goToLarSummary() {
      this.$router.push({ name: 'hmda-lars' })
    },

    onChangeProjectStatus(event) {
      if (
        parseInt(event.target.value) ===
        constant.hmdaProjectStatus.completed.value
      ) {
        this.$refs.msg
          .showAsync(
            constant.projectCompletionConfirmMsg,
            'Confirm',
            'Proceed completing project'
          )
          .then(async () => {
            this.setSpinnerBusy()
            let Payload = {
              projectId: parseInt(this.projectId),
              status: parseInt(event.target.value),
              userid: this.USER_ID,
            }
            await this.updateProject({
              Payload,
            })
            this.getProjectSummary()
            this.getProjectDashboard()
            this.$emit('updateActivityLogs')
          })
          .finally(() => {
            this.unsetSpinnerBusy()
          })
      } else if ((parseInt(event.target.value) === constant.hmdaProjectStatus.inProgress.value)
                 && (parseInt(this.recentProjectStatus) === constant.hmdaProjectStatus.completed.value))
            {
            this.showRuleExecCheckbox = false
              this.$refs.msg
                .showAsync(
                  'Please confirm that you would like to reopen this project',
                  'Confirm',
                  'Proceed reopening project',
                  'Cancel'
                )
                .then(async () => {
                  this.setSpinnerBusy()
                  let Payload = {
                    projectId: parseInt(this.projectId),
                    status: parseInt(event.target.value),
                    userid: this.USER_ID,
                  }
                  await this.updateProject({
                    Payload,
                  })
                  this.getProjectSummary()
                  this.getProjectDashboard()
                  this.$emit('updateActivityLogs')
                })
                .finally(() => {
                    this.unsetSpinnerBusy()
                    this.showRuleExecCheckbox = true
                  })
            }
    },

    onDeleteLoanClick(event) {
      this.modalDelete = this.$refs.msg1
      this.modalDelete.confirmOkClicked = this.deleteConfrimLoans;
      this.modalDelete
        .showAsync(
          'Are you sure you want to delete loan(s)?',
          'Confirm',
          'Delete item(s)'
        );
    },

    deleteConfrimLoans() {
      if (this.deletedOption === 'other' && !this.otherInput.trim()){
        this.showCustomReportIssue = true;

        return;
      }

      let reason = this.deletedOption === 'other' ? this.otherInput : this.deletedOption;
      this.deleteLoanBatch({loanDetailIds: this.selectedLoans, reason: reason})
      .finally(() => {
             this.showCustomReportIssue = false;
             this.deletedOption = '';
             this.otherInput = '';
             this.modalDelete.confirmCancelClicked();
             this.reloadAllData();
          })
    },
  },
}
</script>

<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="msg" modal-size="md">
      <div v-if="isProjectLevelRuleExecution && showRuleExecCheckbox" class="mb-4 mt-n2">
        <b-checkbox
          v-model="isIncludePassedLoans"
          class="d-inline-block w-auto"
        />
        Include passed loans
      </div>

    </BaseModalLayout>

    <BaseModalLayout ref="msg1" modal-size="md">
          <BaseDropdown
            id="text-salutation"
            v-model="deletedOption"
            type="text"
            :options="deletionOptions"></BaseDropdown>

      <div v-if="deletedOption === 'other'">
         <BaseEInputText  v-model="otherInput" type="text" label-content="Input your reason"></BaseEInputText>
      </div>
      <b-row class="mb-4">
        <b-col>
      <div
        v-if="showCustomReportIssue"
        class="error"
        >Reason Is Required
        </div>
        </b-col>

      </b-row>

    </BaseModalLayout>

    <b-row class="mb-4">
      <b-col class="pr-5 mr-2 break-anywhere">
        <h5>Description</h5>
        {{
          !!Object.keys(projectSummary).length
            ? projectSummary.projectDescription || 'No Project Description'
            : '-'
        }}
        <h5 class="mt-3">Template</h5>
        <div>
          <span class="text-capitalize">
            {{
              projectSummary.templateName ? projectSummary.templateName : '-'
            }}
          </span>
        </div>
      </b-col>
      <b-col md="4" class="p-2 rounded-top">
        <table class="float-right mr-2">
          <tr><td class="py-2"></td></tr>
          <tr>
            <td>Project Status</td>
            <td class="pl-4">
              <BaseDropdown
                v-model="projectStatus"
                :options="projectStatuses"
                @change="onChangeProjectStatus"
              />
            </td>
          </tr>
          <tr><td class="py-2"></td></tr>
          <tr>
            <td>
              <BaseEButton
                variant="primary"
                @click="() => onClickRunRules(true)"
              >
                Run Rules
              </BaseEButton>
            </td>
            <td class="pl-4">
              <BaseEButton
                variant="primary"
                pre-icon="list-ul"
                @click="goToLarSummary"
              >
                LAR Summary
              </BaseEButton>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>

    <div class="mb-4">
      <table class="text-center" border width="100%">
        <thead>
          <tr>
            <th colspan="2" style="width:55%"> Total</th>
            <th colspan="4">Results of Executed Loans</th>
          </tr>
          <tr>
            <th>Loans</th>
            <th>Executed Loans - New Loans</th>
            <th>Passed</th>
            <th>Failed</th>
            <th>Error rate</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center sum-attributes">
              {{
                projectDashboard.totalLoans ? projectDashboard.totalLoans : 0
              }}
            </td>
            <td class="text-center sum-attributes">
              {{
                projectDashboard.executedLoans
                  ? projectDashboard.executedLoans
                  : 0
              }}
              -
              {{ projectDashboard.newLoans ? projectDashboard.newLoans : 0 }}
            </td>
            <td class="text-center sum-attributes text-success">
              {{ projectDashboard.passed ? projectDashboard.passed : 0 }}
            </td>
            <td class="text-center sum-attributes text-danger">
              {{ projectDashboard.failed ? projectDashboard.failed : 0 }}
            </td>
            <td class="text-center sum-attributes">
              {{
                projectDashboard.errorRatePercentage
                  ? projectDashboard.errorRatePercentage
                  : 0
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-4">
      <div
        class="d-flex align-items-center cursor-pointer"
        @click="onClickErrorSummary"
      >
        <BaseIcon
          :class="isShowErrorSummary ? null : 'collapsed'"
          :name="isShowErrorSummary ? 'caret-down' : 'caret-right'"
          size="lg"
          class="mr-2"
          style="width: 15px"
        />
        <h4>Error Summary</h4>
      </div>

      <b-collapse id="my-collapse" v-model="isShowErrorSummary">
        <div v-if="errSumArr1 && errSumArr1.length" class="mb-4">
          <b-row>
            <b-col>
              <table class="text-center" border width="100%">
                <thead>
                  <tr>
                    <th>Rules Category</th>
                    <th>Error Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in errSumArr1" :key="index">
                    <td>
                      <span class="text-capitalize">
                        {{ item.name }}
                      </span>
                      <BaseIcon :id="`bi_${index}`" name="info-circle" />
                      <b-tooltip :target="`bi_${index}`" triggers="hover">
                        {{ item.description }}
                      </b-tooltip>
                    </td>
                    <td class="text-center">{{ item.errorCount }} </td>
                  </tr>
                </tbody>
              </table>
            </b-col>

            <b-col>
              <table
                v-if="errSumArr2.length"
                class="text-center"
                border
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Rules Category</th>
                    <th>Error Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in errSumArr2" :key="index">
                    <td>
                      <span class="text-capitalize">
                        {{ item.name }}
                      </span>
                      <BaseIcon :id="`b_${index}`" name="info-circle" />
                      <b-tooltip :target="`b_${index}`" triggers="hover">
                        {{ item.description }}
                      </b-tooltip>
                    </td>
                    <td class="text-center">{{ item.errorCount }} </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </div>
        <div v-else class="bg-light pl-4 p-3">No errors</div>
      </b-collapse>
    </div>

    <div>
      <h4>Rules Execution Summary</h4>
      <b-tabs card>
        <b-tab
          :title="`Failed Loans (${totalFailedLoans})`"
          @click="getTabId(failedLoanId)"
        >
          <div class="mb-4">
            <b-row align-v="end">
              <b-col md="6">
                <FilterDate @getFilteredLoans="getFilteredFailedLoans" />
              </b-col>
            </b-row>
            <BaseDataTable
              ref="loansTable"
              :options="options"
              :items="failedLoansList"
              :fields="fields"
              :commands="failedLoanCommands"
              show-envelope
              show-eye
              showdatatablefooter
              :total-rows="failedLoansRows"
              :per-page="failedLoansPerPage"
              :current-page="failedLoansCurrentPage"
              data-table-selectable
              @rowPerPageChange="rowPerPageCountFailedLoans"
              @paginationEvent="paginationEventFailedLoans"
              @onClickRefItem="goToLoanDetails"
              @sortingChanged="sortingChangedFailedLoans"
              @onCommandEvent="onCommandEvent"
              @onRowSelected="onRowSelected"
            ></BaseDataTable>
          </div>
        </b-tab>

        <b-tab
          :title="`Passed Loans (${totalPassedLoans})`"
          @click="getTabId(passedLoanId)"
        >
          <div class="mb-4">
            <b-row align-v="end">
              <b-col md="6">
                <FilterDate @getFilteredLoans="getFilteredPassedLoans" />
              </b-col>
            </b-row>
            <BaseDataTable
              ref="loansTable"
              :options="options"
              :items="passedLoansList"
              :fields="fields"
              :commands="commands"
              show-envelope
              show-eye
              showdatatablefooter
              :total-rows="passedLoansRows"
              :per-page="passedLoansPerPage"
              :current-page="passedLoansCurrentPage"
              data-table-selectable
              @rowPerPageChange="rowPerPageCountPassedLoans"
              @paginationEvent="paginationEventPassedLoans"
              @onClickRefItem="goToLoanDetails"
              @sortingChanged="sortingChangedPassedLoans"
              @onCommandEvent="onCommandEvent"
              @onRowSelected="onRowSelected"
            ></BaseDataTable>
          </div>
        </b-tab>

        <b-tab
          :title="`New Loans (${totalNewLoans})`"
          @click="getTabId(newLoanId)"
        >
          <div class="mb-4">
            <b-row align-v="end">
              <b-col md="6">
                <FilterDate @getFilteredLoans="getFilteredNewLoans" />
              </b-col>
            </b-row>
            <BaseDataTable
              ref="loansTable"
              :options="options"
              :items="newLoansList"
              :fields="newLoanfields"
              :commands="commands"
              show-envelope
              show-eye
              showdatatablefooter
              :total-rows="newLoansRows"
              :per-page="newLoansPerPage"
              :current-page="newLoansCurrentPage"
              data-table-selectable
              @rowPerPageChange="rowPerPageCountNewLoans"
              @paginationEvent="paginationEventNewLoans"
              @onClickRefItem="goToLoanDetails"
              @sortingChanged="sortingChangedNewLoans"
              @onCommandEvent="onCommandEvent"
              @onRowSelected="onRowSelected"
            ></BaseDataTable>
          </div>
        </b-tab>

           <b-tab
          :title="`Deleted Loans (${totalDeletedLoans})`"
          @click="getTabId(deletedLoanId)"
        >
          <div class="mb-4">
            <b-row align-v="end">

            </b-row>
            <BaseDataTable
              ref="loansTable"
              :options="options"
              :items="deletedLoansList"
              :fields="deletedLoanTable"
              :commands="deletedLoanCommands"
              show-envelope
              show-eye
              showdatatablefooter
              :total-rows="totalDeletedLoans"
              :per-page="deletedLoansPerPage"
              :current-page="deletedLoansCurrentPage"
              data-table-selectable
              @rowPerPageChange="rowPerPageCountDeletedLoans"
              @paginationEvent="paginationEventDeletedLoans"
              @sortingChanged="sortingChangedDeletedLoans"
              @onCommandEvent="onCommandEvent"
              @onRowSelected="onDeletedRowSelected"
            ></BaseDataTable>
          </div>

        </b-tab>

        <!-- <b-tab
          :title="`Datatype Mismatch Loans (${totalDatatypeLoans})`"
          @click="getTabId(dataTypeLoanId)"
        >
          <div class="mb-4">
            <b-row align-v="end">
              <b-col md="6">
                <FilterDate @getFilteredLoans="getFilteredDatatypeLoans" />
              </b-col>
            </b-row>
            <BaseDataTable
              ref="loansTable"
              :options="options"
              :items="datatypeLoansList"
              :fields="newLoanfields"
              :commands="commands"
              show-envelope
              show-eye
              showdatatablefooter
              :total-rows="datatypeLoansRows"
              :per-page="datatypeLoansPerPage"
              :current-page="datatypeLoansCurrentPage"
              data-table-selectable
              @rowPerPageChange="rowPerPageCountDatatypeLoans"
              @paginationEvent="paginationEventDatatypeLoans"
              @onClickRefItem="goToLoanDetails"
              @sortingChanged="sortingChangedDatatypeLoans"
              @onCommandEvent="onCommandEvent"
              @onRowSelected="onRowSelected"
            ></BaseDataTable>
          </div>
        </b-tab> -->
      </b-tabs>
    </div>
  </div>
</template>

<style scoped>
.break-anywhere {
  overflow-wrap: anywhere !important;
}
.sum-attributes {
  height: 60px;
  font-size: 32px;
}
</style>
